export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Account">
      <ui-form-item label="Account Ownership">
        {{ model.account.ownership }}
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
